/**
 * Vue composable that exposes the active Organization metadata and applies
 * the brand primary color to the Vuetify theme.
 *
 * Use this in AppBar / NavigationDrawer / public Manual views instead of
 * pulling from the store directly so the theme override happens in one place.
 */
import { watch } from "vue";
import { useTheme } from "vuetify";

import { useOrganizationStore } from "@/stores/organizationStore";

export function useOrganization() {
  const organizationStore = useOrganizationStore();
  const theme = useTheme();

  // Whenever Organization.primary_color changes, push it into both
  // light and dark themes so the brand applies regardless of theme mode.
  watch(
    () => organizationStore.primaryColor,
    (color) => {
      if (!color) return;
      if (theme.themes.value.light) {
        theme.themes.value.light.colors.primary = color;
      }
      if (theme.themes.value.dark) {
        theme.themes.value.dark.colors.primary = color;
      }
    },
    { immediate: true },
  );

  return {
    organization: organizationStore.organization,
    brandName: organizationStore.brandName,
    logoUrl: organizationStore.logoUrl,
    primaryColor: organizationStore.primaryColor,
    slug: organizationStore.slug,
  };
}
